import { ar } from "zod/v4/locales";

const formatDate = (date, showTime = false,showOnlyMonth = false) => {
  const language = localStorage.getItem("language") || "fr";

  // Messages
  const messages = {
    fr: {
      empty: "Pas de date",
      invalid: "Date invalide",
    },
    en: {
      empty: "No date",
      invalid: "Invalid date",
    },
    ar: {
      empty: "لا يوجد تاريخ",
      invalid: "تاريخ غير صالح",
    },
  };

  const lang = language === "fr" ? "fr" : language === "ar" ? "ar" : "en";

  // Empty check
  if (!date) return messages[lang].empty;

  const parsedDate = new Date(date);

  // Invalid date check
  if (isNaN(parsedDate)) return messages[lang].invalid;

  // Format options
  const options = { year: "numeric", month: "long", day: "numeric" };
  if (showTime) {
    options.hour = "2-digit";
    options.minute = "2-digit";
    options.hour12 = false;
  }
  if (showOnlyMonth) {
    options.year = "numeric";
    options.day = "numeric";
    return parsedDate.toLocaleDateString(lang === "fr" ? "fr-FR" : lang === "ar" ? "ar-MA" : "en-US", { month: "long" });
  }

  return parsedDate.toLocaleDateString(lang === "fr" ? "fr-FR" : lang === "ar" ? "ar-MA" : "en-US", options);
};

export default formatDate;
